import { useCallback, useRef } from 'react'

import {
  useCreateImages,
  useNetwork,
  useUpdateNetwork,
} from '@tribeplatform/react-sdk/hooks'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

import { Logo } from '../../../Logo'

export const SquareLogoPicker = () => {
  const { data: network } = useNetwork()
  const { mutateAsync: updateNetwork, isLoading: isUpdating } =
    useUpdateNetwork()
  const { mutateAsync: createImages, isLoading: isCreatingImage } =
    useCreateImages()
  const fileInputRef = useRef<HTMLInputElement>()

  const onChangeFile = useCallback(
    async e => {
      const file = Array.from(e.target.files)?.[0] as File
      if (!file) return
      try {
        const uploadedImage = await createImages([{ file }])
        await updateNetwork({
          input: {
            faviconId: uploadedImage?.[0]?.id,
          },
        })
        toast({
          title: 'Square logo updated',
          status: 'success',
        })
      } catch (e) {
        toast({
          title: 'Unable to update square logo',
          status: 'error',
        })
      }
    },
    [updateNetwork, createImages],
  )

  return (
    <div className="flex flex-col space-y-1">
      <div className="font-medium text-basicSurface-700">Squared logo</div>
      <div className="flex">
        <div className="relative">
          <Logo
            image={network?.favicon}
            alt="Network square logo"
            size="3xl-square"
          />
          <input
            type="file"
            disabled={isUpdating || isCreatingImage}
            className="hidden"
            multiple={false}
            ref={fileInputRef}
            onChange={onChangeFile}
          />
          <div
            className="flex items-center justify-center text-white bg-black bg-opacity-50 opacity-0 hover:opacity-90 absolute top-0 bottom-0 left-0 right-0 cursor-pointer"
            onClick={() => {
              fileInputRef.current.click()
            }}
          >
            Change
          </div>
          {(isUpdating || isCreatingImage) && (
            <div className="flex items-center justify-center text-white bg-black opacity-50 absolute top-0 bottom-0 left-0 right-0">
              <SpinnerIcon className="animate-spin h-7 w-7" />
            </div>
          )}
        </div>
      </div>
      <FormControl.HelperText>
        1:1 ratio, ideal size of 512x512px. Also used as favicon and mobile home
        screen app icon.
      </FormControl.HelperText>
    </div>
  )
}
